// extracted by mini-css-extract-plugin
export default {"container":"zIrwc","submit-button":"VbeAG","tabs":"qQHPb","tab_content":"M2g_s"};